/**
 * @ngdoc service
 * @name app.service:crudService
 * @description
 * Service permettant l'accès en lecture/écriture aux données présentes en base
 */
app.factory('crudService', ['$http', '$rootScope', '$filter', '$timeout', '$window', '$q', 'modalService', '$state',
    function ($http, $rootScope, $filter, $timeout, $window, $q, modalService, $state) {
        function getConfig(method, url, params, config) {
            var cleanedUrl = crudService.cleanUrlSlashes(url);
            var custom = {method: method, url: cleanedUrl};

            if (method === 'get' || method === 'delete') custom['params'] = params;
            else custom['data'] = params;

            if (method === 'upload') {
                method = 'post';
                custom['method'] = method;
                custom['headers'] = {'Content-Type': undefined, 'enctype': 'multipart/form-data'};
            }

            if (angular.isUndefined(config)) {
                config = {};
            }
            if (angular.isUndefined(config.timeout)) {
                // config.timeout = 60000; // 30000; // timeout du server
                config.timeout = 0;
            }

            if (config.cancelable) {
                crudService.cancelPendingRequest(config.cancelable);
                var canceler = $q.defer();
                config.timeout = canceler.promise;
                config.canceler = canceler;
            }

            // Défini l'option error_code_ignore_modal en tableau vide par défaut si option non définie ou mal définie (Sert à ignorer l'affichage d'une modal selon le code choisi, si il y a une erreur dans la requête)
            if (angular.isUndefined(config.error_code_ignore_modal) || !Array.isArray(config.error_code_ignore_modal)) {
                config.error_code_ignore_modal = [];
            }


            return angular.extend({}, config || {}, custom);
        }


        var crudService = {
            cleanUrlSlashes: function (url) {
                while (url.charAt(url.length - 1) === "/") {
                    url = url.slice(0, -1);
                }
                return url;
            },

            cancelPendingRequests: function () {
                $http.pendingRequests.forEach(function (request) {
                    if (request.canceler) {
							$modal.modal('hide');
                        crudService.cancelRequest(request.canceler);
                    }
                });
            },

            cancelPendingRequest: function (cancelable) {
                $http.pendingRequests.forEach(function (request) {
                    if (request.canceler && request.cancelable === cancelable) {
                        crudService.cancelRequest(request.canceler);
                    }
                });
            },

            cancelRequest: function (canceler) {
                if (!canceler) return;
                canceler.resolve();
                $rootScope.$broadcast('crudService.request.aborted');
            },
            request: function (config) {
                // Event pour activer le loader
                $rootScope.$broadcast('isLoading', {loading: true});

                var startTime = new Date().getTime();
                return $http(config).then(function (response) {
                    $rootScope.$broadcast('isLoading', {loading: false});

                    if (angular.isDefined(response.data.redirectToUrl)) {
                        // $timeout(function () {
                        //     $window.location = response.data.redirectToUrl;
                        // }, 500);
                        window.location.assign(response.data.redirectToUrl);
                    } else if (angular.isDefined(response.data.redirectToRoute)) {
                        $timeout(function () {
                            $state.go(response.data.redirectToRoute, response.data.redirectParams, response.data.redirectOptions);
                        }, 250);
                    } else {
                        return response.data;
                    }

                }, function (response) {

                    var respTime = new Date().getTime() - startTime;

                    $rootScope.$broadcast('isLoading', {loading: false});

                    var status = parseInt(response.status);
                    var title = $filter('capitalize')($filter('translate')('erreur'));
                    var description = $filter('capitalize')($filter('translate')('msg_exception_get_data'));

                    // ne pas faire de return pour afficher la modal d'erreur après redirection
                    if (status == 401) {
                        if ($state.includes('auth')) {
                            window.location.reload(true);
                        } else {
                            // @TODO : temporaire
                            $timeout(function () {
                                $state.go('auth.login');
                            }, 1000);
                        }
                    }
                    if (status == 403 && $state.includes("app")) $state.go('app.home');

                    if (!config.error_code_ignore_modal.includes(status)) { // Si on ignore aucun code erreur OU si le status ne coresponds pas au codes erreurs que l'on veut ignorer
                        if (status == 403 || status == 404 || status == 422) {
                            title = $filter('capitalize')($filter('translate')('titre_erreur_' + response.status));
                            description = $filter('capitalize')($filter('translate')('description_erreur_' + response.status));
                        }

                        if (status > 0 && status != 401) {
                            modalService.show('warning sign', title + ' (' + status + ')', description);
                        }
                        if (angular.isDefined(response.config) && angular.isDefined(response.config.timeout) && response.config.timeout != 0 && respTime >= response.config.timeout) {
                            modalService.show('warning sign',
                                $filter('capitalize')($filter('translate')('titre_erreur_timeout')),
                                $filter('capitalize')($filter('translate')('description_erreur_timeout'))
                            );
                        }
                    }

                    return $q.reject(response);
                });
            }
        };

        angular.forEach(['get', 'delete', 'post', 'put', 'patch', 'upload'], function (method) {
            crudService[method] = function (url, params, config) {
                return this.request(getConfig(method, url, params, config));
            };
        });

        return crudService;
    }]);
